import { defineMessages } from "react-intl";

const messages = defineMessages({
  drillDownSubtitle: {
    id: "dashboard.cards.noContactInCount.drillDown.subTitle",
    defaultMessage: "Calculated every 30 minutes",
    description: "Subtitle of the DrillDown modal of the No Contact In card on the Dashboard page",
  },
});

export default messages;
